import { useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { selectTempOrder, createNewOrderAsync } from "../../Order/orderSlice";
import Loader from "../../../components/Common/Loader";
import toast from 'react-hot-toast';

export default function OrderProcess() {
  const [searchParams] = useSearchParams();
  const paymentIntentId = searchParams.get("payment_intent");
  const redirectStatus = searchParams.get("redirect_status");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tempOrder = useSelector(selectTempOrder);

  // useRef, using this we can prevent to called this api 2 times
  const hasCalledAPI = useRef(false);

  useEffect(() => {
    // 1. Payment status check 
    if (redirectStatus === 'succeeded' && tempOrder && !hasCalledAPI.current) {
      hasCalledAPI.current = true; // API call mark 

      const finalOrder = {
        ...tempOrder,
        paymentMethod: "ONLINEPAYMENT",
        paymentId: paymentIntentId,
        paymentStatus: "paid"
      };

      // 2. BACKEND API HIT (createNewOrderAsync)
      // Ye function fulfilled hone par redux mein currentOrderPlaced set kar dega
      dispatch(createNewOrderAsync(finalOrder)).then((response) => {
        if (response.payload.status === 'success') {

          // 3. FINAL REDIRECT to OrderStatusPage
          navigate(`/order?status=success&order=${response.payload.message.orderId}`);
        } else {
          toast.error("Order creation failed. Please check your orders.");
          navigate('/checkout');
        }
      });
    } else if (redirectStatus === 'failed') {
      toast.error("Payment failed.");
      navigate('/checkout');
    }
  }, [paymentIntentId, redirectStatus, tempOrder, navigate, dispatch]);

  return (
    <div className="flex flex-col justify-center items-center min-h-[calc(100vh-200px)] bg-white px-4">
      <Loader />
      <h2 className="text-xl font-semibold mt-6 text-indigo-600 text-center">
        Processing Your Request...
      </h2>
      <p className="text-gray-500 mt-2 text-sm italic text-center max-w-xs">
        Please do not refresh the page or click back button.
      </p>
    </div>
  );
}